import { render, staticRenderFns } from "./QuestionSubSection.vue?vue&type=template&id=63abdf58&scoped=true"
import script from "./QuestionSubSection.vue?vue&type=script&lang=js"
export * from "./QuestionSubSection.vue?vue&type=script&lang=js"
import style0 from "./QuestionSubSection.vue?vue&type=style&index=0&id=63abdf58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63abdf58",
  null
  
)

export default component.exports